import PicabooConstants from '../common/PicabooConstants';

function allProjectTypes() {
  return [
    { name: 'Books', projectType: PicabooConstants.PRODUCT_TYPES.BOOK },
    { name: 'Cards', projectType: PicabooConstants.PRODUCT_TYPES.CARD },
    {
      name: 'Framed Canvas',
      projectType: PicabooConstants.PRODUCT_TYPES.CANVAS,
    },
    { name: 'Calendars', projectType: PicabooConstants.PRODUCT_TYPES.CALENDAR },
    {
      name: 'Collage Posters',
      projectType: PicabooConstants.PRODUCT_TYPES.COLLAGE,
    },
    {
      name: 'Photo Panels',
      projectType: PicabooConstants.PRODUCT_TYPES.PHOTO_PANEL,
    },
    { name: 'Prints', projectType: PicabooConstants.PRODUCT_TYPES.PRINTS },
    {
      name: 'Metal Prints',
      projectType: PicabooConstants.PRODUCT_TYPES.METAL_PRINT,
    },
    {
      name: 'Scrapbook Pages',
      projectType: PicabooConstants.PRODUCT_TYPES.SQUARE_PRINT,
    },
    {
      name: 'Mouse Pads',
      projectType: PicabooConstants.PRODUCT_TYPES.MOUSE_PAD,
    },
    { name: 'Notebook', projectType: PicabooConstants.PRODUCT_TYPES.NOTEBOOK },
    { name: 'Journal', projectType: PicabooConstants.PRODUCT_TYPES.JOURNAL },
    { name: 'Pillow', projectType: PicabooConstants.PRODUCT_TYPES.PILLOW },
    { name: 'Blanket', projectType: PicabooConstants.PRODUCT_TYPES.BLANKET },
    { name: 'Tote Bag', projectType: PicabooConstants.PRODUCT_TYPES.TOTE },
    {
      name: 'Playing Cards',
      projectType: PicabooConstants.PRODUCT_TYPES.PLAYING_CARDS,
    },
    { name: 'Crystal', projectType: PicabooConstants.PRODUCT_TYPES.CRYSTAL },
    { name: 'Ornament', projectType: PicabooConstants.PRODUCT_TYPES.ORNAMENT },
    { name: 'Coaster', projectType: PicabooConstants.PRODUCT_TYPES.COASTER },
    { name: 'Mug', projectType: PicabooConstants.PRODUCT_TYPES.MUG },
    { name: 'Frames', projectType: PicabooConstants.PRODUCT_TYPES.FRAME },
    {
      name: 'Giclée Prints',
      projectType: PicabooConstants.PRODUCT_TYPES.PHOTO_POSTER,
    },
  ];
}

export function getUserProjectTypes(projects) {
  let activeProductTypes = [];
  const foundTypes = {};

  projects.forEach((project) => {
    foundTypes[project.projectType] = project.projectType;
  });

  Object.keys(foundTypes).forEach((key, index) => {
    let pt = allProjectTypes().find((t) => {
      return '' + t.projectType === key;
    });

    if (pt) {
      activeProductTypes.push(pt);
    } else {
      console.warn('Unknown Product Type', key);
    }
  });

  activeProductTypes = activeProductTypes.sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  return activeProductTypes;
}

export function projectsOfType(projects, projectType) {
  return projects
    .filter((p) => {
      return p.projectType === projectType;
    })
    .sort((a, b) => {
      return a.projectTitle
        .toLowerCase()
        .localeCompare(b.projectTitle.toLowerCase());
    })
    .map((p) => {
      p.name = p.projectTitle;
      return p;
    });
}

export function getProjectTitle(project) {
  return project.get('name') ? project.get('name') : '';
}

export function getProjectAuthor(project) {
  return project.get('projectAuthor') ? project.get('projectAuthor') : '';
}

export function getProductText(projectProduct) {
  let productText = '';
  if (projectProduct) {
    let productSize = projectProduct.get('size')
      ? projectProduct.get('size')
      : '';
    let productDescription = projectProduct.get('description')
      ? projectProduct.get('description')
      : 'project';
    productText +=
      (productSize.length > 0 ? productSize : '') + ' ' + productDescription;
  }
  return productText;
}
